import {h, Fragment, render} from 'preact';
import {useEffect, useRef, useState} from 'preact/hooks';
import Button from "./components/Button";
import Question from "./components/Question";
import Answers from "./components/Answers";
import References from "./components/References";
import Comments from "./components/Comments";

(() => {
    function Quiz({nodeRef, csrfToken, is}) {
        const [error, setError] = useState(false);
        const [isFetching, setIsFetching] = useState(false);
        const [valid, setIsValid] = useState(false);
        const [result, setResult] = useState(false);
        const formData = useRef();
        useEffect(() => { }, [valid]);

        const updateStatus = async (data) => {
            let body = {node: nodeRef, is: is}
            const path = data !== null && data.path !== null ? data.path : '';
            const answer =  data !== null && data.answer !== null ? data.answer : '';

            if (answer) { body.answer = answer };
            setIsFetching(true);

            /** extract it */
            fetch(`/api/quiz` + path, {
                cache: "no-cache",
                method: "POST",
                body: JSON.stringify(body),
                credentials: 'same-origin',
                headers: {
                    'X-Flow-Csrftoken': csrfToken,
                    'Content-Type': 'application/json'
                }
            }).then((response) => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Erreur serveur!');
            }).then((data) => {
                setTimeout(() => setIsFetching(false), 1000);
                setResult(data);
            }).catch((error) => {
                setIsFetching(false);
                setError(error);
            });
        }

        const handleSubmit = (ev ) => {
            ev.preventDefault();
            let value = formData.current.answer.value;
            if (value === '') {
                setError('Problème avec le quiz, rechargez la page.')
            }
            updateStatus({path: '/validate', answer: value});
        };

       const setButtonActive = (ev ) => {
            ev.preventDefault();
           setIsValid(true);
        };

        // firstload
        useEffect(() => {
            updateStatus(null);
        }, []);

        if (result.show) {
            return (
                <Fragment>
                    <Question label={result.question} />
                    <Answers items={result.answers} onRadioChecked={setButtonActive} disabled={true} />
                    <div className="oQuiz__Result">
                        <h2 className="oQuiz__Result__Headline aHeadline aHeadline--Secondary">{result.answerTitle}</h2>
                        <Comments items={result.comments} />
                        <References items={result.refs} />
                    </div>
                </Fragment>
            );
        }

        return (
            <Fragment>
                <Question label={result.question} />
                <form onSubmit={handleSubmit} ref={formData}>
                    <Answers items={result.answers} onRadioChecked={setButtonActive} />
                    <Button valid={valid} />
                </form>
            </Fragment>
        );
    }

    window.addEventListener('DOMContentLoaded', () => {
        const QuizElement = document.querySelector('#BddQuiz');
        if (!QuizElement) return;
        const {node, token, is} = QuizElement.dataset;
        if (node === '' || token === '') return;

        render(<Quiz nodeRef={node} csrfToken={token} is={is}/>, QuizElement);
    });
})();
